var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { Route, Switch } from "react-router-dom";
import OrganizationsList from "./OrganizationsList";
import OrganizationForm from "./OrganizationForm";
var Organizations = function (_a) {
    var match = _a.match;
    return (React.createElement(Switch, null,
        React.createElement(Route, { path: "".concat(match.path, "/create"), render: function (routeProps) { return React.createElement(OrganizationForm, __assign({ key: "create" }, routeProps)); } }),
        React.createElement(Route, { path: "".concat(match.path, "/:id/edit"), render: function (routeProps) { return (React.createElement(OrganizationForm, __assign({ key: "edit-".concat(routeProps.match.params.id) }, routeProps))); } }),
        React.createElement(Route, { path: ["".concat(match.path, "/:id"), match.path], render: function (routeProps) { return (React.createElement(OrganizationsList, { match: match, selectedId: routeProps.match.params.id })); } })));
};
export default Organizations;
